import React from 'react';
import Select from 'react-select';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { baseAPI } from '../config';
import { toast } from 'react-toastify';
import userStore from '../store/userStore';

const AssignOperator = ({ currentUser, expedient }) => {
  const { operators, setOperators } = userStore();
  const showAssignOperator =
    (currentUser?.role === 'admin' || currentUser?.role === 'company') && !expedient?.user_id?.operators_handle_all;

  const mapOperators = operators => {
    if (!operators) return [];
    return operators.map(operator => ({
      value: operator._id,
      label: operator.username + ' ' + operator.userlastname[0] + '. ' + operator.usermail,
    }));
  };

  const [selectedOperators, setSelectedOperators] = useState(mapOperators(expedient.operator_ids) || []);

  const loadOperators = useCallback(async () => {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(`${baseAPI}/users?company=${expedient?.user_id._id.toString()}`, { headers });
    setOperators(response.data || []);
  }, [expedient?.user_id._id, setOperators]);

  const handleChange = async selectedOptions => {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const selectedOperatorsIds = selectedOptions.map(option => option.value);
    const response = await axios.post(
      `${baseAPI}/expedients/update/${expedient._id.toString()}`,
      {
        operator_ids: selectedOperatorsIds.map(id => id.toString()),
      },
      { headers }
    );

    if (response.status === 200) {
      toast.success('Operadores asignados correctamente');
    } else {
      toast.error('Error al asignar operadores');
    }

    setSelectedOperators(selectedOptions);
  };

  useEffect(() => {
    if (showAssignOperator && !operators) {
      loadOperators();
    }
  }, [showAssignOperator, loadOperators, operators]);

  useEffect(() => {
    const operators = mapOperators(expedient.operator_ids);
    setSelectedOperators(operators);
  }, [expedient?.operator_ids]);

  if (showAssignOperator) {
    return (
      <div>
        <h2 className='text-sm font-medium text-gray-500 mb-2'>Assignado a:</h2>
        <Select
          options={mapOperators(operators)}
          value={selectedOperators}
          isMulti
          onChange={handleChange}
          placeholder='Selecciona los operadores...'
          onMenuOpen={loadOperators}
        />
      </div>
    );
  }

  return null;
};

export default AssignOperator;
